import Api from "../Api";

class SystemApi {
    getSystemConfigLogOut = () => {
        return Api.get("/system-config/auto-logout", {}, {});
    }
}

export default new SystemApi();
